import { IndicatorBadge } from '@carvana/ds-badge';
import type { ChipProps } from '@carvana/ds-chip';
import { background } from '@carvana/ds-styles';
import { Settings2 } from 'lucide-react';
import { useContext } from 'react';
import Chip from '@/common/Chip';
import ModalContext, {
  type FilterModalOpenSource
} from '~/context/srp/ModalContext/ModalContext';
import useAppliedFilterTagsCount from '~/hooks/common/searches/useAppliedFilterTagsCount';

type OwnProps = {
  className?: string;
  dataAdobeId?: string;
  dataAnalyticsAttributes?: string;
  dataAnalyticsId?: string;
  shape?: ChipProps['shape'];
  source?: FilterModalOpenSource;
  testId?: string;
};

export default function FilterMenuChip({
  className,
  dataAdobeId = 'filter-menu',
  dataAnalyticsAttributes,
  dataAnalyticsId = 'Filter Menu',
  shape = 'rectangle',
  source,
  testId = 'open-filter-modal'
}: OwnProps) {
  const { setFilterModalOpen } = useContext(ModalContext);
  const numberOfTags = useAppliedFilterTagsCount();

  return (
    <Chip
      className={className}
      data-adobe-id={dataAdobeId}
      data-analytics-attributes={dataAnalyticsAttributes}
      data-analytics-id={dataAnalyticsId}
      data-testid={testId}
      onClick={() =>
        source ? setFilterModalOpen(true, source) : setFilterModalOpen(true)
      }
      shape={shape}
      testId={testId}
    >
      <Settings2 size={16} />
      {numberOfTags > 0 && (
        <IndicatorBadge
          customBackground={background.strong}
          priority="custom"
          size="lg"
        >
          {numberOfTags.toLocaleString()}
        </IndicatorBadge>
      )}
    </Chip>
  );
}
